<template>
  <div>
      <Header title="考试安排"></Header>
      <NOdata v-if="testArrange.length == 0 && isLoad" title="暂无考试安排~"></NOdata>
      <template v-else>
        <div class="grey-contain" v-for="(item,index) in testArrange" :key="index">
          <div>
            <p class="contain-txt" v-if=" schoolCode != '10045'">{{item.courseName}}</p>
            <p class="contain-txt" v-else>{{item.courseName}} ({{ item.jsxm }})</p>

            <p class="contain-txt1" v-if=" schoolCode != '10045'">位置：{{item.examinationPlace}}</p>
            <p class="contain-txt1" v-else>考场：{{item.examinationPlace}}</p>

            <p class="contain-txt1" v-if=" schoolCode != '10045'">时间：<span style="color: #F86969;">{{item.time}}</span></p>
            <p class="contain-txt1" v-if=" schoolCode == '10045' && zssj1 != null  && zssj2 != null ">时间：<span style="color: #F86969;">{{item.ksqssj}}  {{item.zssj1}}  {{item.zssj2}}</span></p>
            <p class="contain-txt1" v-if="schoolCode == '10045' && (zssj1 == null  || zssj2 == null )">时间：<span style="color: #F86969;">{{item.time}}</span></p>
          </div>
        </div>

        <van-popup v-model="textShow" class="popup">
        <div class="poup-list">
          <div
            class="poup-list-item"
          >
            <div class="popup-header">
              <h3>
                考风考纪承诺书
              </h3>
            </div>
            <ul class="popup-content">
              <p v-html="context"></p>
            </ul>
          </div>
        </div>
        <div class="qz-button-group">
          <template >
            <van-button type="danger" style="width: 48%;float: left;" @click="cnsclose(2)" >不同意 </van-button>
            <van-button type="info" style="width: 48%;float: right;" @click="cnsclose(1)" >同意 </van-button>
          </template>
        </div>
    </van-popup>

      </template>
  </div>
</template>

<script>
  import { Api } from '../../utils/axios'
  export default {
    data(){
      return{
        casLogin:sessionStorage.getItem('casLogin'),
        testArrange:[],
        isLoad:false,
        schoolCode: "",
        textShow:false,
        closesecend: 0,
        context:"",
        kw0401id:"",
      }
    },
    methods:{
      async cnsclose(type) {
        const params = {
          'kw0401id':this.kw0401id,
          'type':type
        }
        const res = await Api.cnsSava(params)
        if(res.code = '1'){
          this.textShow = false;
        }
      },
      async getList(){
        const params = {
          'semester':''
        }
        const res = await Api.examinationArrangement()
        this.testArrange = res.data;
        if(res.kw0401id != null && res.kw0401id != '' && this.schoolCode == '10541'){
          this.context = res.context;
          this.kw0401id = res.kw0401id;
          this.textShow = true;
        }
        this.isLoad = true;
      }
    },
    created(){
      this.schoolCode = sessionStorage.getItem("schoolCode");
      this.getList()
    },
  }
</script>

<style lang="less" scoped>
.grey-contain .contain-txt{line-height: 22px;}
.grey-contain .contain-txt1{line-height: 17px;}
.grey-contain>div>p:nth-child(2){margin-bottom: 2px;}

.popup {
  width: 311px;
  height: 777px;
  background: #ffffff;
  border-radius: 8px;
  padding: 20px;

  .close {
    position: absolute;
    top: 17px;
    right: 17px;
    width: 24px;
    height: 24px;
    padding: 3px;
    box-sizing: border-box;
  }

  .poup-list {
    overflow: auto;
    height: calc(~"100% - 55px");
    .poup-list-item {
      .popup-header h2 {
        font-family: PingFangSC-Medium;
        font-weight: bolder;
        font-size: 18px;
        color: #333333;
        line-height: 18px;
        margin-bottom: 15px;
      }

      .popup-content {
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #999999;
        line-height: 21px;
        li {
          display: flex;
          p {
            white-space: nowrap;
          }
          & + li {
            margin-top: 4px;
          }
        }
      }

      & + div {
        margin-top: 20px;
      }
    }
  }
  .qz-button-group {
    padding: 10px 20px 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/student/exam.vue